export const errorCodes = {
  None: 0,
  InvalidTourId: 4,
  TourBookingEventOptionSubmitTourIdMismatch: 6,
  TourBookingEventOptionSubmitNoTourFound: 7,
  TourBookingTravelOptionLoadNoTourFound: 19,
  TourBookingTravelOptionSubmitNoTourFound: 21,
  TourBookingPassengerDetailsLoadNoTourFound: 30,
  TourBookingPassengerDetailsSubmitNoTourFound: 32,
  TourBookingSummaryLoadNoTourFound: 35,
  TourBookingSummarySubmitNoTourFound: 37,
  TourBookingStopoverOptionLoadNoTourFound: 58,
  TourBookingStopoverOptionSubmitNoTourFound: 60,
  TourBookingTourHasReachedPaxCapLimit: 70,
  StandalonePaymentDetailsLoadExpired: 83,
  StandalonePaymentDetailsSubmitExpired: 84,
  StandalonePaymentDetailsSubmitNoSettings: 85,
  InvalidPriorityAccessPassOptionKey: 95,
  PriorityAccessPassBookingDetailsSubmitNoPapOptionFound: 100,
  PriorityAccessPassBookingSummaryLoadNoPapOptionFound: 102,
  TourBookingSummaryLoadFailedToRetrieveBookingSettings: 110,
  TourBookingSummarySubmitFailedToRetrieveBookingSettings: 111,
  TourBookingSummarySubmitInvalidPaymentOption: 112,
  PriorityAccessPassBookingSummarySubmitFailedToRetrieveBookingSettings: 115,
  PriorityAccessPassBookingSummarySubmitInvalidPaymentOption: 116,
  PriorityAccessPassBookingSummaryLoadFailedToRetrieveBookingSettings: 117,
  StandalonePaymentDetailsSubmitInvalidPaymentOption: 118,
  StandalonePaymentDetailsLoadFailedToRetrieveBookingSettings: 125,
  PriorityAccessPassBookingSummarySubmitNoPapOptionFound: 143,
  validationGenericPaxInvalidDateOfBirth: 177,
};

export const getErrorMessageKey = (errorCode) => {
  let errorMessageKey = null;

  switch (errorCode) {
    case errorCodes.InvalidTourId:
    case errorCodes.TourBookingEventOptionSubmitNoTourFound:
    case errorCodes.TourBookingStopoverOptionLoadNoTourFound:
    case errorCodes.TourBookingStopoverOptionSubmitNoTourFound:
    case errorCodes.TourBookingTravelOptionLoadNoTourFound:
    case errorCodes.TourBookingTravelOptionSubmitNoTourFound:
    case errorCodes.TourBookingPassengerDetailsLoadNoTourFound:
    case errorCodes.TourBookingPassengerDetailsSubmitNoTourFound:
    case errorCodes.TourBookingSummaryLoadNoTourFound:
    case errorCodes.TourBookingSummarySubmitNoTourFound:
      errorMessageKey = 'invalidTourIdMessage';
      break;
    case errorCodes.TourBookingEventOptionSubmitTourIdMismatch:
      errorMessageKey = 'sessionInvalidTourIdMessage';
      break;
    case errorCodes.TourBookingSummaryLoadFailedToRetrieveBookingSettings:
    case errorCodes.TourBookingSummarySubmitFailedToRetrieveBookingSettings:
    case errorCodes.PriorityAccessPassBookingSummaryLoadFailedToRetrieveBookingSettings:
    case errorCodes.PriorityAccessPassBookingSummarySubmitFailedToRetrieveBookingSettings:
    case errorCodes.StandalonePaymentDetailsLoadFailedToRetrieveBookingSettings:
    case errorCodes.StandalonePaymentDetailsSubmitNoSettings:
      errorMessageKey = 'failedToRetrieveCheckoutProcessSettingsMessage';
      break;
    case errorCodes.TourBookingSummarySubmitInvalidPaymentOption:
    case errorCodes.PriorityAccessPassBookingSummarySubmitInvalidPaymentOption:
    case errorCodes.StandalonePaymentDetailsSubmitInvalidPaymentOption:
      errorMessageKey = 'invalidPaymentOptionMessage';
      break;
    case errorCodes.InvalidPriorityAccessPassOptionKey:
    case errorCodes.PriorityAccessPassBookingDetailsSubmitNoPapOptionFound:
    case errorCodes.PriorityAccessPassBookingSummaryLoadNoPapOptionFound:
    case errorCodes.PriorityAccessPassBookingSummarySubmitNoPapOptionFound:
      errorMessageKey = 'invalidPriorityAccessPassIdErrorMessage';
      break;
    case errorCodes.StandalonePaymentDetailsLoadExpired:
    case errorCodes.StandalonePaymentDetailsSubmitExpired:
      errorMessageKey = 'sessionExpiredMessage';
      break;
    case errorCodes.validationGenericPaxInvalidDateOfBirth:
      errorMessageKey = 'validationGenericPaxInvalidDateOfBirth';
      break;
    default:
  }

  return errorMessageKey;
};

export const vynePaymentErrorCodes = {
  bankTransferNoConsent: 1,
  bankTransferNoConfirm: 2,
  bankTransferExpired: 3,
  bankTransferFailed: 7,
};

export const getVynePaymentErrorMessageKey = (vynePaymentErrorCode) => {
  let vynePaymentErrorMessageKey = null;

  switch (vynePaymentErrorCode) {
    case vynePaymentErrorCodes.bankTransferNoConsent:
      vynePaymentErrorMessageKey = 'bankTransferNoConsentMessage';
      break;
    case vynePaymentErrorCodes.bankTransferNoConfirm:
      vynePaymentErrorMessageKey = 'bankTransferNoConfirmMessage';
      break;
    case vynePaymentErrorCodes.bankTransferExpired:
      vynePaymentErrorMessageKey = 'bankTransferExpiredMessage';
      break;
    case vynePaymentErrorCodes.bankTransferFailed:
      vynePaymentErrorMessageKey = 'bankTransferFailedMessage';
      break;
    default:
  }
  return vynePaymentErrorMessageKey;
};
